module.exports = __webpack_public_path__ + "img/category-new-released-hover.97849daa.png";